// src/contexts/AuthContext.js
import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => {
    const stored = localStorage.getItem("auth");
    return stored ? JSON.parse(stored) : null;
  });

  const isAuthenticated = !!auth?.token;

  const login = ({ token, user }) => {
    const payload = { token, user };
    localStorage.setItem("auth", JSON.stringify(payload));
    setAuth(payload);
  };

  const logout = () => {
    localStorage.removeItem("auth");
    setAuth(null);
  };

  // Function to get authorization header for API requests
  const getAuthHeaders = () => {
    if (!auth?.token) return {};
    return {
      'Authorization': `Bearer ${auth.token}`,
      'Content-Type': 'application/json'
    };
  };

  return (
    <AuthContext.Provider value={{ 
      auth, 
      isAuthenticated, 
      login, 
      logout, 
      getAuthHeaders 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
